import { relaunchFilters } from '../../../assets/js/events/utils';
import { refreshCriticalPathIsNeeded } from '../../../assets/js/events/onAfterAutoSchedule/refreshCriticalPathIsNeeded';
import { columnCache } from '../../../services/columnCache';
function onEditEnd(state, t) {
  columnCache.invalidateCache();
  const gantt = window.to_use_react_gantt;
  if (!gantt.isTaskExists(state.id)) return;
  if (state.columnName === 'progress') {
    const progress = Number(gantt.getTask(state.id).progress);

    if (progress === 100) {
      gantt.completeTask(state.id);
    }

    if (progress === 0) {
      gantt.uncompleteTask(state.id);
    }

    gantt.updateExpectedGlobal();
    refreshCriticalPathIsNeeded();
    relaunchFilters([state.id], t);
  }
  gantt.is_task_moved = false;
  gantt.isEditingInline = false;
}

export { onEditEnd };